import React, { useContext } from "react";
import { useQuery } from "react-query";
import { QK } from "../../../base/qk";
import { getRecordAbsense } from "../../../api/services/notification";
import TableComponent from "../../TableComponent/TableComponent";
import { formatDateAndTime } from "../../../base/FormatTime"; // 🟡 import the new function
import MyContext from "../../../context/MyContext";

const RecordAbsenseContent = () => {
  const { locationID } = useContext(MyContext);
  const { data: absense, isLoading } = useQuery(
    [QK.recordAbense, locationID],
    () => getRecordAbsense(locationID),
    { keepPreviousData: true, enabled: !!locationID }
  );

  const columns = [
    {
      field: "client_name",
      headerName: "Client Name",
    },
    {
      headerName: "Absense From",
      render: (value, row) => formatDateAndTime(row.start_date, row.start_time),
    },
    {
      headerName: "Absense To",
      render: (value, row) => formatDateAndTime(row.end_date, row.end_time),
    },
    { field: "absence_type", headerName: "Absense Type" },
    { field: "reason", headerName: "Absense Reason" },
    { field: "contact_information", headerName: "Contact" },
  ];

  return (
    <div>
      <TableComponent
        columns={columns}
        data={absense || []}
        isLoading={isLoading}
        size="medium"
      />
    </div>
  );
};

export default RecordAbsenseContent;
